export default {
  // Endpoints
  loginEndpoint: '/api/login',
  forgotEndpoint: '/api/forgot',
  secondFactorEndpoint: '/api/second-factor',
  registerEndpoint: '/api/register',
  // PROP-086: refreshEndpoint '/jwt/refresh-token' убран — роута на бэке не существует, а
  // refresh-флоу в jwtService снят (дёргал несуществующий путь и всё равно разлогинивал).
  logoutEndpoint: '/api/logout',
  whoamiEndpoint: '/api/whoami',
  changepassEndpoint: '/api/changepassword',
  // PROP-230: пользовательский токен доступа — выпуск, просмотр, отзыв (одна ручка,
  // действие в поле `action`). Работает только под парольной сессией.
  apiTokenEndpoint: '/api/token',
  queryEndpoint: '/api/qry',
  uploadEndpoint: '/api/upload',
  uploadchunkEndpoint: '/api/uploadchunk',
  downloadEndpoint: '/api/download',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  storageCubusTokenKeyName: 'cubusToken',

  // PROP-087: здесь стоял заголовок ЗАПРОСА 'Access-Control-Allow-Origin': '*'. Смысла он не
  // имел никогда: ACAO — заголовок ОТВЕТА, браузер его от клиента не принимает, а отправка
  // нестандартного заголовка лишь превращает простые запросы в preflight. Политику CORS задаёт
  // сервер (play.filters.cors.allowedOrigins), клиенту тут сказать нечего.
  headers: {},
}
